/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: a3bf36714875
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * Managed delivery types for assets uploaded and stored by Cloudinary.
 */
export const ManagedDeliveryType = {
  Upload: "upload",
  Private: "private",
  Authenticated: "authenticated",
} as const;
/**
 * Managed delivery types for assets uploaded and stored by Cloudinary.
 */
export type ManagedDeliveryType = ClosedEnum<typeof ManagedDeliveryType>;

export const ManagedDeliveryType$zodSchema = z.enum([
  "upload",
  "private",
  "authenticated",
]).describe(
  "Managed delivery types for assets uploaded and stored by Cloudinary.",
);
